import styled from 'styled-components';

export const RadioContainer = styled.div`
  display: flex;
  width: 140px;
  height: 40px;
  align-items: flex-start;
`;
